/**
 * Directive for the Edit Portal Page Portal Contact section.
 * Do not change the directive name here as its used dynamically in the view to load multiple instances
 */
SUGApp.directive("sugContact", function() {
    return({
        restrict: "A",
        templateUrl: "/view/tools/portals/dspSectionContact.html",
        scope: {
            data: '=',
            section: '='
        },
        controller: ['$scope','$filter','$timeout','SUGUtilities','errorService','portalService',
            function($scope , $filter , $timeout , SUGUtilities , errorService , portalService) {
            // $scope refers to scope of this perticular directive instance.

            //init error service
            $scope.es = errorService;
            $scope.es.init();

            //use this to display data to the view
            $scope.frmObj = {
                  contactname:      ''
                , contactidslist:   ''
                , contactlink:      ''
            };

            //Set dynamic disable and processing vars so you only impact a specific directive instance
            $scope['frmDisableField'+$scope.section.id] = false;
            $scope['isProcessing'+$scope.section.id] = false;

            // Handler for Processing Status
            $scope.$on('isProcessingContact', function (event, objProcessing) {
                //Verify the event has a valid object and is for this specific section instance
                if(    typeof objProcessing === "object"
                && typeof objProcessing.sectionId !== 'undefined'
                && typeof objProcessing.isprocessing !== 'undefined'
                && objProcessing.sectionId == $scope.section.id){
                    $scope['isProcessing'+$scope.section.id] = objProcessing.isprocessing;
                    disableForm(objProcessing.isprocessing);
                }
            });

            //manage disabling the form
            var disableForm = function (blnDisabled) {
                $scope['frmDisableField'+$scope.section.id] = blnDisabled;
            };

            /**
             * Listens for the contact save event from the slide out so you can update the specific directive
             */
            $scope.$on('portal_savecontact', function (evt,val) {
                //if the event has a valid value and is for this specific section instance, then update groups
                if(    typeof val === "object"
                    && typeof val.sectionId !== 'undefined'
                    && typeof val.contactData !== 'undefined'
                    && val.sectionId == $scope.section.id)
                {
                    $scope.frmObj.contactname = val.contactData.contactname;
                    $scope.frmObj.contactidslist = val.contactData.contactids.join(',');
                }
            });

            /**
             * Method loads the contact details info for the contact section directive
             */
            var parseData = function(){
                //toggle spinner and form disable
                SUGUtilities.broadCast('isProcessingContact', { 'sectionId': $scope.section.id, 'isprocessing': true });

                var objContent = JSON.parse( $scope.section.sectioncontent );
                $scope.frmObj.contactname = objContent.contactname;
                $scope.frmObj.contactidslist = objContent.contactids.join(',');

                $scope.frmObj.contactlink = $scope.data.fullsecureurl +  '/?go=c.help&mid=' + $scope.data.parentId + '&pid=' + $scope.data.portalInfo.portal.id + '&sid=' + $scope.section.id + '&uky=' + encodeURI( $scope.data.portalInfo.portal.urlkey ) + '&portal=1';

                if( !$scope.frmObj.contactname.length ){
                    loadData();
                } else {
                    updateSectionContent();

                    //toggle spinner and form disable
                    SUGUtilities.broadCast('isProcessingContact', { 'sectionId': $scope.section.id, 'isprocessing': false });
                }
            };

            /**
             * Method loads the creator as the contact when no Contact data has been saved
             */
            var loadData = function(){
                portalService.loadContactData({
                              parentId: $scope.data.parentId
                            , memberId: $scope.data.memberId
                            , sectionContent: JSON.parse( $scope.section.sectioncontent )
                    }).then(function( response ){
                        //validate the response
                        if( SUGUtilities.ajaxResultInvalid( response.data ) ){
                            //toggle spinner and form disable
                            SUGUtilities.broadCast('isProcessingContact', { 'sectionId': $scope.section.id, 'isprocessing': false });

                            $scope.es.setError('contactsection', SUGUtilities.getAjaxResponseMessage(response) );
                        } else {
                            //response was valid
                            var r = SUGUtilities.lowerCaseKeys( response.data );
                            if( r.success && r.data.contactname.length){
                                $scope.frmObj.contactname = r.data.contactname;
                                $scope.frmObj.contactidslist = r.data.contactids.join(',');
                            }
                            updateSectionContent();

                            //toggle spinner and form disable
                            SUGUtilities.broadCast('isProcessingContact', { 'sectionId': $scope.section.id, 'isprocessing': false });
                        }
                });
            };

            /**
             * Updated the specific sectioncontent with relevant info for this section
             */
            var updateSectionContent = function(){
                var sectionContactObj = JSON.parse( $scope.section.sectioncontent );
                sectionContactObj.contactname = $scope.frmObj.contactname;
                $scope.section.sectioncontent = JSON.stringify(sectionContactObj);
            };



            parseData();

        }]  // end contact directive controller

    }); //end Return
});  // END sugContact